import {REST_METHODS} from '@/src/app/constants/api';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const resetPasswordAction = (email) => {
  return unauthorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/auth/password`,
    body: {
      user: {
        email,
      },
    },
  });
};

export default resetPasswordAction;
